// Example Markup
// {
/* <li class="secondary-heading js-expand-trigger cursor-pointer">
    Visit
</li>
    <ul class="expand-content pt-2">
    {% for location in locations %}
        <li class="secondary-heading pb-2">
            <a href="/{{ location.uri }}">{{ location.title }}</a>
        </li>
    {% endfor %}
</ul> */
// }

function expand(trigger) {
  // Hide active content
  const windowPosition = window.scrollY;

  window.scrollTo(0, windowPosition);

  const activeTrigger = document.querySelector('.js-expand-trigger.active');

  if (activeTrigger) {
    activeTrigger.classList.remove('active');
    const content = activeTrigger.nextElementSibling;
    const indicator = activeTrigger.querySelector('.js-expand-indicator');
    content.classList.toggle('expand');
    content.style.maxHeight = 0;
    window.scrollTo(0, windowPosition);

    if (indicator) {
      indicator.classList.remove('active');
    }
  }

  if (activeTrigger !== trigger) {
    // Show content based on trigger clicked on
    trigger.classList.toggle('active');

    const content = trigger.nextElementSibling;
    const indicator = trigger.querySelector('.js-expand-indicator');
    content.classList.toggle('expand');

    if (content.style.maxHeight === '0px' || content.style.maxHeight === '') {
      const height = content.scrollHeight;
      content.style.maxHeight = `${height}px`;

      if (indicator) {
        indicator.classList.add('active');
      }
    } else {
      content.style.maxHeight = 0;
      window.scrollTo(0, windowPosition);

      if (indicator) {
        indicator.classList.remove('active');
      }
    }
  }
}

function initializeExpand() {
  const expandTriggers = document.querySelectorAll('.js-expand-trigger');

  expandTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      expand(trigger);
    });
  });
}

function checkActiveOnLoad() {
  const activeTrigger = document.querySelector('.js-expand-trigger.active-on-load');

  if (activeTrigger) {
    expand(activeTrigger);
  }
}

(() => {
  function init() {
    initializeExpand();
    checkActiveOnLoad();
  }

  init();
})();
